window.addEventListener('OpusCartChange', (event) => {
    const data = event.detail;
    const sectionCustom = document.querySelector('#opus-price-ct-container');

    if (sectionCustom) {
        sectionCustom.remove();
    }

    const stringOpus = window.localStorage.getItem('opusCartV2');
    const ObjectPrice = JSON.parse(stringOpus);
    let discountCompare = 0;
    const listItemDetail = data.items;

    for (const item of listItemDetail) {
        const listKeys = Object.keys(ObjectPrice);
        if (listKeys.includes(`${item.id}`)) {
            const ogPrice = ObjectPrice[`${item.id}`]?.compareAtPrice || 0;
            if (ogPrice) {
                const flPrice = item.final_price;
                const lastPrice = ogPrice - flPrice;
                discountCompare += lastPrice * item.quantity;
            }
        }
    }

    let totalDiscount = data.total_discount + discountCompare;
    const discountCodeElement = document.querySelector('.cd-warp-list');

    if (!data.total_discount) {
        discountCodeElement.classList.add('display_none');
    } else {
        discountCodeElement.classList.remove('display_none');
    }

    const oldElement = document.querySelector('.cd-checkout-section-discount-amount');
    
    if (totalDiscount >= 0) {
        if (oldElement) {
            const newElement = document.createElement('div');
            newElement.className = 'cd-checkout-section-discount-amount';
            newElement.textContent = `-${window.OpusConvertMoney(totalDiscount)}`;
            oldElement.replaceWith(newElement);
        } else {
            const checkoutBtn = document.querySelector('#opus-checkout-btn');
            if (checkoutBtn) {
                const discountElement = document.createElement('div');
                discountElement.className = 'cd-checkout-section-discount-amount';
                discountElement.textContent = `-${window.OpusConvertMoney(totalDiscount)}`;
                checkoutBtn.parentNode.insertBefore(discountElement, checkoutBtn);
            }
        }
    } else {
        if (oldElement) {
            oldElement.classList.add('display_none');
        }
    }
});
